import React from 'react';
import styles from './DeliveryInquiry.module.css';
import ImageUpload from "../../../utils/adminsMaster/ImageUpload";

const DeliveryInquiry: React.FC = () => {
    return (
        <div>
            <div>
                <ImageUpload/>
            </div>
        </div>
    );
};

export default DeliveryInquiry;
